import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from 'react-router-dom'
import { IntlProvider } from 'react-intl'
import AppLocale from './lang'
import NotificationContainer from './components/common/react-notifications/NotificationContainer'
import main from './views/app/main'
import app from './views/app'
import trial from './views/app/trial'
import summary from './views/app/summary'
import paraphraseChatGPT from './views/app/paraphrase-chatgpt'
import summaryChatGPT from './views/app/summary-chatgpt'
import copychecker from './components/copychecker'
// import login from './views/user/login'
// import register from './views/user/register'
// import recover from './views/user/recover'
// import confirm from './views/user/confirm'
import error from './views/error'
import { setButtonLoading } from './redux/actions'

const AuthRoute = ({ component: Component, authUser, ...rest }) => {
  const { path } = { ...rest }

  // if (path === '/') return <Redirect to={{ pathname: '/login' }} />

  // se usuário está logado, não será possível visualizar as páginas login, register e recover
  if (path === '/login' || path === '/register' || path === '/recover') {
    if (authUser !== null) return <Redirect to={{ pathname: '/app' }} />

    // if (path === '/login') return <Route path={path} component={login} />
    // if (path === '/register') return <Route path={path} component={register} />
    // if (path === '/recover') return <Route path={path} component={recover} />
  }

  // se usuário estiver logado, poderá acessar as outras páginas que usam o AuthRoute
  return (
    <Route
      {...rest}
      render={props => (authUser ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: '/login',
            state: { from: props.location }
          }}
        />
      ))
      }
    />
  )
}

// class App extends React.Component {
const App = (props) => {
  const { locale, loginUser } = props
  const currentAppLocale = AppLocale[locale]

  useEffect(() => {
    document.body.classList.add('ltr')
    document.body.classList.remove('rtl')

    document.body.onmousedown = (e) => {
      if (e.button === 1) return false
      return true
    }
  }, [])

  return (
    <div className="h-100">
      <IntlProvider
        locale={currentAppLocale.locale}
        messages={currentAppLocale.messages}
      >
        <React.Fragment>
          <NotificationContainer />
          <Router>
            <Switch>
              <Route path="/app/trial" component={trial} />
              <Route path="/app/summary2" component={summaryChatGPT} />
              <Route path="/app/summary" component={summary} />
              <Route path="/app/paraphrase2" component={paraphraseChatGPT} />
              <Route path="/app/copychecker" component={copychecker} />
              <Redirect exact from="/app" to="app/paraphrase" />
              <AuthRoute path="/app" authUser={loginUser} component={app} />
              {/* <AuthRoute
                path="/login"
                authUser={loginUser}
                component={login}
              />
              <AuthRoute
                path="/register"
                authUser={loginUser}
                component={register}
              />
              <AuthRoute
                path="/recover"
                authUser={loginUser}
                component={recover}
              />
              <Route path="/confirm" component={confirm} /> */}
              <Route path="/error" exact component={error} />
              <Route path="/" exact component={main} />
              <Route path="/paraphrase" exact component={main} />
              <AuthRoute
                path="/"
                exact
                component={main}
              />
              <Redirect to="/error" />
            </Switch>
          </Router>
        </React.Fragment>
      </IntlProvider>
    </div>
  )
}

const mapStateToProps = ({ authUser, settings }) => {
  const { token: loginUser } = authUser
  const { locale } = settings
  return { loginUser, locale }
}
const mapActionsToProps = {
  onSetButtonLoading: setButtonLoading
}

export default connect(mapStateToProps, mapActionsToProps)(App)
